var exports = {
  "$": "Button__AZN9RT",
};

module.exports = exports;
